import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

import MenuButton from 'Common/MenuButton/MenuButton';
import MenuPage from 'Common/Navigation/MenuPage';
import { infoToastAction } from 'utils';

const Menu = ({ onChange }) => {
	const { isSupervisor } = useSelector(globalState => globalState.user);
	const globalDispatch = useDispatch();

	const handleEmailTemplate = useCallback(() => {
		if (isSupervisor) {
			onChange('email_templates');
		} else {
			globalDispatch(infoToastAction('Supervisor access is required to access email template configuration.'));
		}
	}, [isSupervisor, globalDispatch, onChange]);

	const handleResetRejected = useCallback(() => {
		if (isSupervisor) {
			onChange('reset_contract');
		} else {
			globalDispatch(infoToastAction('Supervisor access is required to access email template configuration.'));
		}
	}, [isSupervisor, globalDispatch, onChange]);

	const handleRetrieveContract = useCallback(() => {
		if (isSupervisor) {
			onChange('retrieve_contract');
		} else {
			globalDispatch(infoToastAction('Supervisor access is required to access retrieve contracts.'));
		}
	}, [isSupervisor, globalDispatch, onChange]);

	const handleRetrieveTaskHistory = useCallback(() => {
		if (isSupervisor) {
			onChange('retrieve_taskhistory');
		} else {
			globalDispatch(infoToastAction('Supervisor access is required to access task history.'));
		}
	}, [isSupervisor, globalDispatch, onChange]);

	return (
		<>
			<MenuPage title="Utilities">
				<MenuButton
					title="Email Templates"
					icon={() => <FontAwesomeIcon icon={faCopy} size="9x" />}
					width="80%"
					onClick={handleEmailTemplate}
					supervisorOnly={true}
				/>
				<MenuButton
					title="Reset Rejected Contract"
					icon={() => <FontAwesomeIcon icon={faCopy} size="9x" />}
					width="80%"
					onClick={handleResetRejected}
					supervisorOnly={true}
				/>
				<MenuButton
					title="Retrieve Contract and Terms"
					icon={() => <FontAwesomeIcon icon={faCopy} size="9x" />}
					width="80%"
					onClick={handleRetrieveContract}
					supervisorOnly={true}
				/>
				<MenuButton
					title="Retrieve Task History"
					icon={() => <FontAwesomeIcon icon={faCopy} size="9x" />}
					width="80%"
					onClick={handleRetrieveTaskHistory}
					supervisorOnly={true}
				/>
			</MenuPage>
		</>
	);
};

export default Menu;
